import PropTypes from "prop-types";
import { useState } from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

const CounterUpItem = ({ data }) => {
  const [didViewCountUp, setDidViewCountUp] = useState(false);

  const onVisibilityChange = (isVisible) => {
    if (isVisible) {
      setDidViewCountUp(true);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center text-center px-6 py-8 h-full">
      <img src={data.icon} alt="icon" className="w-10 h-10 mb-2 sm:mb-3" />
      <div className="text-4xl font-bold flex items-center">
        <VisibilitySensor
          onChange={onVisibilityChange}
          offset={{ top: 10 }}
          delayedCall
        >
          <div className="flex items-center">
            <CountUp end={didViewCountUp ? data.number : 0} />
            <span>+</span>
          </div>
        </VisibilitySensor>
      </div>
      <p className="mt-1 sm:mt-2 text-base sm:text-lg font-medium">
        {data.text}
      </p>
    </div>
  );
};

CounterUpItem.propTypes = {
  data: PropTypes.object,
};

export default CounterUpItem;
